import { Box, Stack } from "@mui/material";
import { use, useEffect, useRef, useState } from "react";
import { GLItemsDTO } from "../../../DTO/GLItemsDTO";
import LogChatCreateMsg from "./LogChatCreateMsg";
import LogChatMsg from "./LogChatMsg";
import { InfinitScroll } from "../../../services/InfinitScroll";
import { GLItemKind, GLItemStatus } from "../../../DTO/GLItemDTO";

enum Status {
    loading,
    loadMore,
    idle,
}

export default function LogChat({
    id,
    personId,
    disableNewMsg,
    needle,
    kind,
    statusKind,
    onClickDetail,
}: {
    id?: number,
    personId?: number,
    disableNewMsg?: boolean,
    needle?: string,
    kind?: GLItemKind,
    statusKind?: GLItemStatus,
    onClickDetail?: (id: number) => void,
}) {
    const [status, setStatus] = useState(Status.loading)
    const [glitems] = useState(new GLItemsDTO({
        id: id && id > -1 ? id : undefined,
        page: 1,
        limit: 20,
        personId,
        needle,
        kind,
        status: statusKind,
    }))
    useEffect(() => {
        setStatus(Status.loading)
        glitems.patchRequest({
            personId,
            kind,
            status: statusKind,
        })
        glitems.getFresh().then(() => setStatus(Status.idle))
    }, [personId, kind, statusKind])

    useEffect(() => {
        setStatus(Status.loading)
        glitems.setNeedle(needle || '').then(() => setStatus(Status.idle))
    }, [needle])
    
    async function refresh() {
        setStatus(Status.loading)
        await glitems.getFresh()
        setStatus(Status.idle)
    }

    const [infinitScroll] = useState(new InfinitScroll({
        ref: useRef(null),
        cb: async () => {
            console.log('infinitscroll cb')
            if (!glitems.allowInfinitScroll) { return }
            setStatus(Status.loadMore)
            await glitems.getNextPage()
            setStatus(Status.idle)
        },
        saveScrollPositionCb: (scrollPosition: number) => {
            console.log('current scroll position')
        },
        page: 1,
    }))

        
    return <Box>       
        <Stack
          spacing={4}
          ref={infinitScroll.getRef()}
          className={`LogChat scrollContent`}
          sx={{
            maxHeight: '90vh'
          }}
        >
            {
                !disableNewMsg &&
                <LogChatCreateMsg
                    saveCB={refresh}
                    personId={personId}
                    id={id}
                />
            }
            {status === Status.loading && <Box>Lade...</Box>}
            {status !== Status.loading && glitems.items.length === 0 && <Box>Keine Einträge</Box>}
            {status !== Status.loading && glitems.get().map(item =>
            <LogChatMsg
                key={item.id}
                saveCB={refresh}
                item={item}
                onClickDetail={onClickDetail}
            />)}    
        </Stack>
    </Box>
}
